<div class="step-three" [class.step-three--edit]="isEditStepper">
  <div class="step-three__layout">
    <div class="step-three__back">
      <ds-button-v2
        emphasis="terciary"
        size="xs"
        leadingIcon="ArrowBack"
        [label]="isEditStepper ? stepThree.editBack : stepThree.back"
        (clicked)="goBack()"
      ></ds-button-v2>
    </div>

    <div class="step-three__columns">
      <div class="step-three__primary">
        <div class="step-three__heading">
          <p class="step-three__flow">{{ stepThree.flowName }}</p>
          <div class="step-three__heading-text">
            <h2 class="step-three__title">{{ isEditStepper ? stepThree.editTitle : stepThree.title }}</h2>
            <p class="step-three__subtitle">{{ stepThree.subtitle }}</p>
          </div>
        </div>

        <ds-card shadow="l2">
          <section class="step-three__card">
            <div class="step-three__card-header">
              <h3 class="step-three__card-title">{{ stepThree.cardTitle }}</h3>
              <p class="step-three__card-subtitle">{{ stepThree.cardSubtitle }}</p>
            </div>

            <div class="step-three__field" [formGroup]="formRut">
              <p class="step-three__question">{{ stepThree.rutLabel }}</p>

              <div class="step-three__search">
                <ds-input-text
                  class="step-three__search-field"
                  visualTransformation="rut"
                  [maxCharacters]="9"
                  [showMaxCharacters]="false"
                  [placeholder]="stepThree.rutPlaceholder"
                  [value]="rutValue"
                  [state]="rutNotFound ? 'error' : 'default'"
                  [helpText]="stepThree.rutError"
                  [showHelpText]="rutNotFound"
                  (valueChange)="onRutChange($event)"
                ></ds-input-text>

                <div class="step-three__search-action">
                  <ds-button-v2
                    emphasis="secondary-outlined"
                    size="s"
                    [fullWidth]="true"
                    maxWidth="100%"
                    [disabled]="!canSearch"
                    [label]="isSearchingEmployer ? stepThree.searchingButton : stepThree.searchButton"
                    (clicked)="searchEmployer()"
                  ></ds-button-v2>
                </div>
              </div>

              <div *ngIf="employerData" class="step-three__employer">
                <p class="step-three__employer-name">{{ employerData.employerName }}</p>

                <dl class="step-three__employer-data">
                  <div *ngFor="let field of employerFields" class="step-three__employer-item">
                    <dt class="step-three__employer-label">{{ field.label }}</dt>
                    <dd class="step-three__employer-value">{{ employerValue(field.key) }}</dd>
                  </div>
                </dl>

                <div class="step-three__field step-three__field--email" [formGroup]="formEmail">
                  <div class="step-three__search step-three__search--labeled">
                    <ds-input-text
                      class="step-three__search-field"
                      type="email"
                      [label]="stepThree.emailLabel"
                      [placeholder]="stepThree.emailPlaceholder"
                      [value]="emailValue"
                      [disabled]="emailSaved"
                      [state]="isEmailInvalid ? 'error' : 'default'"
                      [helpText]="stepThree.emailError"
                      [showHelpText]="isEmailInvalid"
                      (valueChange)="onEmailChange($event)"
                      (blurred)="onEmailBlur()"
                    ></ds-input-text>

                    <div class="step-three__search-action">
                      <ds-button-v2
                        emphasis="secondary-outlined"
                        size="s"
                        [fullWidth]="true"
                        maxWidth="100%"
                        [disabled]="!canToggleEmail"
                        [label]="emailSaved ? stepThree.emailUpdateButton : stepThree.emailButton"
                        (clicked)="toggleEmail()"
                      ></ds-button-v2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </ds-card>

        <div class="step-three__submit">
          <div class="step-three__submit-action">
            <ds-button-v2
              emphasis="primary"
              size="m"
              [fullWidth]="true"
              maxWidth="100%"
              [disabled]="!canContinue"
              [label]="isEditStepper ? stepThree.editSubmit : stepThree.submitButton"
              (clicked)="isEditStepper ? saveChanges() : goToNextStep()"
            ></ds-button-v2>
          </div>
        </div>
      </div>

      <app-stepper-lateral
        *ngIf="!isEditStepper"
        class="step-three__stepper"
        [currentStep]="currentStepIndex"
      ></app-stepper-lateral>
    </div>
  </div>
</div>
